import { render } from "./ChannelOverall.vue?vue&type=template&id=d2958f48"
import script from "./ChannelOverall.vue?vue&type=script&lang=js"
export * from "./ChannelOverall.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__